import { render, staticRenderFns } from "./MerchantGatewayShow.vue?vue&type=template&id=096e05af&"
import script from "./MerchantGatewayShow.vue?vue&type=script&lang=js&"
export * from "./MerchantGatewayShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports